import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import styles from './styles.scss'

const RevisionDropdownContainer = (props) => {
  return (
    <Flex styleName='revisionDropdownContainer'>
      {props.children}
    </Flex>
  )
}

export default CSSModules(styles)(RevisionDropdownContainer)